/* eslint-disable */
import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'

  },
  direction: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginLeft: 5,
    width: 25
  },
  marginRight: {
    marginRight: 10
  }
})
